import i18n from "i18next";
import IdealStudio from "../../../../../core/editor/main";
import colors_texture from "./../../../../../dist/images/colors_texture.jpg";
import desert from "./../../../../../dist/images/desert.jpg";
import forest from "./../../../../../dist/images/forest.jpg";
import jungle from "./../../../../../dist/images/jungle.jpg";
import meadow from "./../../../../../dist/images/meadow.jpg";
import placeholder from "./../../../../../dist/images/placeholder.svg";
export const templates = () => {
  return [
    {
      name: "templates.template1",
      boxes: [
        {
          box: {
            x: "0",
            y: "0",
            width: "25%",
            height: "100%",
          },
          toolbar: {
            name: "HotspotImages",
            url: colors_texture,
          },
          thumbnail: {
            icon: "filter_hdr",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "30%",
            y: "10%",
            width: "60%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.text_images",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "30%",
            y: "30%",
            width: "60%",
            height: "40%",
          },
          toolbar: {
            name: "BasicText",
            text: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque diam urna, hendrerit porta sollicitudin nec, gravida quis massa. Aenean ac mi nulla. Phasellus ac dui consectetur, ultrices dui at, convallis quam. Quisque ac varius nibh. Pellentesque egestas, sem a placerat laoreet, enim lectus volutpat nisi, at vulputate tortor leo ac risus. Mauris pretium et enim eu faucibus. Vestibulum ornare odio eget eros ullamcorper, et iaculis libero venenatis. </p>",
          },
          thumbnail: {
            icon: "format_align_left",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: "templates.template2",
      boxes: [
        {
          box: {
            x: "3%",
            y: "5%",
            width: "45%",
            height: "43%",
          },
          toolbar: {
            name: "BasicText",
            style: { backgroundColor: "#ff444d" },
            initialState: {
              __i18nKey: "templates.add_text",
              __prefix: "<div class='template2_item'>",
              __suffix: "</div>",
            },
          },
          thumbnail: {
            icon: "format_align_left",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "51%",
            y: "5%",
            width: "45%",
            height: "43%",
          },
          toolbar: {
            name: "BasicText",
            style: { backgroundColor: "#4cff9f" },
            initialState: {
              __i18nKey: "templates.add_text",
              __prefix: "<div class='template2_item'>",
              __suffix: "</div>",
            },
          },
          thumbnail: {
            icon: "format_align_left",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "3%",
            y: "52%",
            width: "45%",
            height: "43%",
          },
          toolbar: {
            name: "BasicText",
            style: { backgroundColor: "#65caff" },
            initialState: {
              __i18nKey: "templates.add_text",
              __prefix: "<div class='template2_item'>",
              __suffix: "</div>",
            },
          },
          thumbnail: {
            icon: "format_align_left",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "51%",
            y: "52%",
            width: "45%",
            height: "43%",
          },
          toolbar: {
            name: "BasicText",
            style: { backgroundColor: "#ffbf45" },
            initialState: {
              __i18nKey: "templates.add_text",
              __prefix: "<div class='template2_item'>",
              __suffix: "</div>",
            },
          },
          thumbnail: {
            icon: "format_align_left",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },
      ],
    },
    {
      name: "templates.template3",
      boxes: [
        {
          box: {
            x: "3%",
            y: "5%",
            width: "45%",
            height: "43%",
          },
          toolbar: {
            name: "HotspotImages",
            url: forest,
          },
          thumbnail: {
            icon: "filter_hdr",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "51%",
            y: "5%",
            width: "45%",
            height: "43%",
          },
          toolbar: {
            name: "HotspotImages",
            url: jungle,
          },
          thumbnail: {
            icon: "filter_hdr",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "3%",
            y: "52%",
            width: "45%",
            height: "43%",
          },
          toolbar: {
            name: "HotspotImages",
            url: desert,
          },
          thumbnail: {
            icon: "filter_hdr",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "51%",
            y: "52%",
            width: "45%",
            height: "43%",
          },
          toolbar: {
            name: "HotspotImages",
            url: meadow,
          },
          thumbnail: {
            icon: "filter_hdr",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },
      ],
    },
    {
      name: "templates.template4",
      boxes: [
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.video",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "5%",
            y: "15%",
            width: "90%",
            height: "80%",
          },
          toolbar: {
            name: "EnrichedPlayer",
            url: "https://www.youtube.com/watch?v=g72QtrZufpM",
          },
          thumbnail: {
            icon: "play_circle_outline",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: "templates.template5",
      boxes: [
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.map",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "5%",
            y: "15%",
            width: "90%",
            height: "80%",
          },
          toolbar: {
            name: "VirtualTour",
          },
          thumbnail: {
            icon: "map",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: "templates.template6",
      boxes: [
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.web",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "5%",
            y: "15%",
            width: "90%",
            height: "80%",
          },
          toolbar: {
            name: "Webpage",
            url: "https://www.ideaelearning.net/",
          },
          thumbnail: {
            icon: "public",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: "templates.template7",
      boxes: [
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.elements_list",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "5%",
            y: "22%",
            width: "43%",
            height: "73%",
          },
          toolbar: {
            name: "HotspotImages",
            url: placeholder,
          },
          thumbnail: {
            icon: "filter_hdr",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "52%",
            y: "22%",
            width: "43%",
            height: "73%",
          },
          toolbar: {
            name: "BasicText",
            text:
              "<ul class='bulleted_list'><li>" +
              i18n.t("templates.first_element") +
              "</li><li>" +
              i18n.t("templates.second_element") +
              "</li><li>" +
              i18n.t("templates.third_element") +
              "</li><li>...</li> </ul>",
          },
          thumbnail: {
            icon: "format_list_bulleted",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: "templates.template8",
      boxes: [
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.ex_unique_response",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "5%",
            y: "23%",
            width: "90%",
            height: "auto",
            heightTemplate: "72%",
          },
          toolbar: {
            name: "MultipleChoice",
          },
          thumbnail: {
            icon: "radio_button_checked",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: "templates.template9",
      boxes: [
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.ex_multiple_response",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "5%",
            y: "23%",
            width: "90%",
            height: "auto",
            heightTemplate: "72%",
          },
          toolbar: {
            name: "MultipleAnswer",
          },
          thumbnail: {
            icon: "check_box",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: "templates.template10",
      boxes: [
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.ex_free_response",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "5%",
            y: "23%",
            width: "90%",
            height: "auto",
            heightTemplate: "72%",
          },
          toolbar: {
            name: "FreeResponse",
          },
          thumbnail: {
            icon: "message",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: "templates.template11",
      boxes: [
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.ex_true_false",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "5%",
            y: "23%",
            width: "90%",
            height: "auto",
            heightTemplate: "72%",
          },
          toolbar: {
            name: "TrueFalse",
          },
          thumbnail: {
            icon: "check_circle",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: "templates.template12",
      boxes: [
        {
          box: {
            x: "3%",
            y: "5%",
            width: "85%",
            height: "83%",
          },
          toolbar: {
            name: "BasicText",
            url: forest,
            initialState: {
              __i18nKey: "templates.ex_background_sound",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "filter_hdr",
            icon_color: "#B2B2B2",
            color: "#706F6F",
          },
        },

        {
          box: {
            x: "1%",
            y: "1%",
            width: "3%",
            height: "5%",
          },
          toolbar: {
            name: "BackgroundSound",
            url: "https://www.youtube.com/watch?v=g72QtrZufpM",
          },
          thumbnail: {
            icon: "play_circle_outline",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },

    {
      name: "templates.template13",
      boxes: [
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.ex_matching",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "5%",
            y: "23%",
            width: "90%",
            height: "auto",
            heightTemplate: "72%",
          },
          toolbar: {
            name: "Matching",
          },
          thumbnail: {
            icon: "radio_button_checked",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },

    {
      name: "templates.template14",
      boxes: [
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "12%",
          },
          toolbar: {
            name: "BasicText",
            initialState: {
              __i18nKey: "templates.ex_fill-in-the-blank",
              __prefix: "<h1 class='no_margins'>",
              __suffix: "</h1>",
            },
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#706F6F",
          },
        },
        {
          box: {
            x: "5%",
            y: "23%",
            width: "90%",
            height: "auto",
            heightTemplate: "72%",
          },
          toolbar: {
            name: "FillInBlank",
          },
          thumbnail: {
            icon: "format_list_bulleted",
            icon_color: "#706F6F",
            color: "#B2B2B2",
          },
        },
      ],
    },
  ];
};

/**
 * Templates whose plugins are all registered in IdealStudio.Config.pluginList.
 * createBox() silently skips unregistered plugins, so a template referencing
 * one (VirtualTour, Webpage, the removed BackgroundSound) would open as an
 * empty scene. Such templates are hidden until their plugin is enabled again.
 */
export const availableTemplates = () =>
  templates().filter((template) =>
    template.boxes.every((item) => IdealStudio.Plugins.get(item.toolbar.name))
  );
